module.exports = __webpack_public_path__ + "assets/images/ic-alarm.3e2b0d4d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/ic-alarm.svg
// module id = 448
// module chunks = 1